<div class="container px-m">
  @for (elem of optionArray; track elem) {
  <div class="multi-selection-box py-s">
    <mat-checkbox
      color="primary"
      [(ngModel)]="elem.isSelected"
      (ngModelChange)="onOptionChange()"
      (click)="$event.stopPropagation()"
    >
      {{ elem.label }}</mat-checkbox
    >
  </div>
  }
</div>
